import { __awaiter, __generator } from "tslib";
import React, { useContext, useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import { FilterContext } from "@contexts/FilterContext";
import { PriorityAPIContext } from "@shared/contexts/api";
import { PriorityExtractors } from "@shared/models/priority";
import { CollapsibleInlineFilter } from "./CollapsibleInlineFilter";
export var PriorityFilter = React.memo(function (props) {
    var filterKey = props.filterKey, isCollapsed = props.isCollapsed, onToggle = props.onToggle;
    var intl = useIntl();
    var priorityAPI = useContext(PriorityAPIContext);
    var _a = useContext(FilterContext), appliedFilters = _a.appliedFilters, setAppliedFilter = _a.setAppliedFilter;
    var fetchOptions = useCallback(function (page, perPage, options) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, priorityAPI.listPriorities({
                    page: page,
                    perPage: perPage,
                    search: options.search,
                })];
        });
    }); }, [priorityAPI]);
    var onSelect = useCallback(function (items) {
        setAppliedFilter({ priorities: items });
    }, [setAppliedFilter]);
    var title = useMemo(function () {
        return intl.formatMessage({ id: "common.tags.priority" });
    }, [intl]);
    var searchPlaceholder = useMemo(function () {
        return intl.formatMessage({ id: "common.search" });
    }, [intl]);
    var onToggleFilter = useCallback(function () {
        onToggle(filterKey);
    }, [filterKey, onToggle]);
    return (React.createElement(CollapsibleInlineFilter, { isCollapsed: isCollapsed, onToggle: onToggleFilter, selected: appliedFilters.priorities, onSelect: onSelect, getOptions: fetchOptions, title: title, searchPlaceholder: searchPlaceholder, labelExtractor: PriorityExtractors.name, descriptionExtractor: PriorityExtractors.fullName, keyExtractor: PriorityExtractors.id }));
});
